import useShowFormikErrors from "../../hooks/useShowFormikErrors";
import { FormikErrors } from "formik";
import React from "react";
type AbwesenheitShowErrorsProps = {
  children: React.ReactNode;
  errors: FormikErrors<any>;
};

export default function ShowFormikErrors({
  children,
  errors,
}: AbwesenheitShowErrorsProps) {
  const tooltip = useShowFormikErrors({ errors });

  return <div title={tooltip.tooltipMessage}>{children}</div>;
}
